import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import IncentiveContainer from './container/IncentiveContainer';
import ApprehensionContainer from './container/ApprehensionContainer';
import PaymentContainer from './container/PaymentContainer';
import AmnestyContainer from './container/AmnestyContainer';
import ExportsContainer from './container/ExportsContainer';

function ReportsContainer({ match, pathName }) {
  const permissions = getJson('permissions');
  return (
    <div className="card-content-listing">
      <div className="container-fluid">
        <div className="row">
          <ul className="nav nav-tabs btn-settings-tab-container">
            <li className="nav-item">
              <Link
                to="/ordinance-violation-receipts/reports"
                className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                  pathName.indexOf(
                    '/ordinance-violation-receipts/reports/incentive'
                  ) > -1
                    ? 'selected'
                    : ''
                }`}
              >
                Incentive
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/ordinance-violation-receipts/reports/apprehension"
                className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                  pathName.indexOf(
                    '/ordinance-violation-receipts/reports/apprehension'
                  ) > -1
                    ? 'selected'
                    : ''
                }`}
              >
                Apprehension
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/ordinance-violation-receipts/reports/payment"
                className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                  pathName.indexOf(
                    '/ordinance-violation-receipts/reports/payment'
                  ) > -1
                    ? 'selected'
                    : ''
                }`}
              >
                Payment
              </Link>
            </li>
            {Acl(permissions, ['VIEW OVRS REPORTS TAX AMNESTY']) && (
              <li className="nav-item">
                <Link
                  to="/ordinance-violation-receipts/reports/amnesty"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/ordinance-violation-receipts/reports/amnesty'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Amnesty
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link
                to="/ordinance-violation-receipts/reports/exports"
                className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                  pathName.indexOf(
                    '/ordinance-violation-receipts/reports/exports'
                  ) > -1
                    ? 'selected'
                    : ''
                }`}
              >
                Exports
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/incentive`} />}
        />
        <Route
          path={`${match.path}/incentive`}
          component={IncentiveContainer}
        />
        <Route
          path={`${match.path}/apprehension`}
          component={ApprehensionContainer}
        />
        <Route path={`${match.path}/payment`} component={PaymentContainer} />
        {Acl(permissions, ['VIEW OVRS REPORTS TAX AMNESTY']) && (
          <Route path={`${match.path}/amnesty`} component={AmnestyContainer} />
        )}
        <Route path={`${match.path}/exports`} component={ExportsContainer} />
      </Switch>
    </div>
  );
}

ReportsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(ReportsContainer);
